const useExtraScript = () => {
    const { isMrbilit } = useWhiteLabel();
    if (isMrbilit.value) {
        useSchemaOrg([
            defineOrganization({
                '@context': 'http://schema.org',
                '@type': 'Organization',
                name: 'مستربلیط',
                url: 'https://mrbilit.com',
                sameAs: [
                    'https://www.instagram.com/mrbilit',
                    'https://www.linkedin.com/company/mrbilit',
                    'https://twitter.com/mrbilit',
                ],
                contactPoint: {
                    '@type': 'ContactPoint',
                    telephone: '+982161169000',
                    contactType: 'customer service',
                },
                logo: 'https://mrbilit.com/img/mrbilit-logo-with-name.png',
            }),
            defineWebSite({
                '@id': 'https://mrbilit.com/#website',
                '@type': 'WebSite',
                description: 'وب سایت مستربلیط',
                name: 'مستربلیط',
                url: 'https://mrbilit.com/',
                publisher: {
                    '@id': 'https://mrbilit.com/#identity',
                },
            }),
        ]);

        if (!process.client || !(window as any).yektanet) {
            useScriptTag(
                '/js/yektanet.js',
                (_el: HTMLScriptElement) => {
                    // do something
                },
                {
                    async: true,
                    defer: true,
                    type: 'text/javascript',
                    attrs: {
                        id: 'ua-script-yn-1493-adv',
                        'data-analyticsobject': 'yektanet',
                    },
                }
            );
        }
    }
};

export default useExtraScript;
